/*
 * Corresponds to ChangeTypes.cs on the back end
 */
export const changeTypes = {
  ACTUAL_STOPS: 'job_stops',
  ACTUAL_STOP_DELETED: 'actual_stop_deleted',
  SKIPPED_STOPS: 'skipped_stop',
  APPROVED: 'approved',
  ASSIGNED_TO_POOL: 'assigned_to_pool',
  AVAILABILITY_ACCEPTED: 'availability_accepted',
  AVAILABILITY_DECLINED: 'availability_declined',
  INVENTORY_RECEIPTS: 'job_inventory_receipts',
  MODIFIED: 'modified',
  REJECTED_APPROVAL: 'rejected_approval',
  REOPEN: 'reopen',
  REQUESTED_STOPS: 'requested_stops',
  SIGNATURE_DELETED: 'signature_deleted',
  SIGNED: 'signed',
  SUBMITTED_FOR_APPROVAL: 'submitted_for_approval',
  UNAPPROVED: 'unapproved',
}
